import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {change} from "redux-form/immutable";
import Form from "./AddPalletForm";
import {cancelAddPalletToTransfer, successAddPalletToTransfer} from "../../../actions/StockTransferApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "kind");
  errors = validatePresence(errors, values, "palletIds");
  return errors.toJS();
}

// Scanned or pasted ids: one per line, or separated by spaces or commas.
function parsePalletIds(text) {
  return (text || "").split(/[\s,;]+/).map((id) => id.trim()).filter((id) => id !== "");
}

class AddPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [], added: 0 }
  }

  // The backend adds the pallets one after the other. Those it refuses stay in
  // the box with the reasons, so they can be corrected and submitted again.
  handleSubmit(values) {
    const data = {
      transferId: this.props.transferId,
      kind: values.get("kind"),
      palletIds: parsePalletIds(values.get("palletIds")),
    };

    return this.props.addPalletsToTransfer(data)
      .then((response) => {
        const result = response.data.addPalletsToTransfer;
        if (result.errors.length <= 0) {
          this.props.successAddPalletToTransfer();
        } else {
          const refused = result.errors.map((error) => error.key).filter((id, i, ids) => ids.indexOf(id) === i);
          this.props.change("AddPalletToTransferForm", "palletIds", refused.join("\n"));
          this.setState({
            added: this.state.added + result.added.length,
            errors: {_error: result.errors.map((error) => error.message).join("\n")}
          });
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelAddPalletToTransfer();
  }

  render() {
    return (
      <Form
        initialValues={Map({kind: "water"})}
        errors={this.state.errors}
        added={this.state.added}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ADD_PALLETS_TO_TRANSFER = gql`
  mutation addPalletsToTransfer($data: AddPalletsToTransferInput!) {
    addPalletsToTransfer(input: $data) {
      added
      errors { key message }
    }
  }
`;

const withMutation = graphql(ADD_PALLETS_TO_TRANSFER, {
  props: ({ mutate }) => ({
    addPalletsToTransfer: (data) => mutate({
      variables: { data: data }
    })
  })
});

export default connect(null, {cancelAddPalletToTransfer, successAddPalletToTransfer, change})(withMutation(AddPalletFormContainer));
